import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';

export const ConfirmLocalPayment = () => gql`
  mutation ConfirmLocalPayment($params: ConfirmLocalPaymentParams!) {
    confirmLocalPayment(params: $params) {
      id
      status
      orderGroupId
      uuid
    }
  }
`;

export type ConfirmLocalPaymentMutationParams = ResolverParams<{
  orderUuid: string;
}>;

export type ConfirmLocalPaymentMutationResponse = {
  confirmLocalPayment: Order;
};
